import { render, staticRenderFns } from "./AttachmentsViewer.vue?vue&type=template&id=4746d688&"
import script from "./AttachmentsViewer.vue?vue&type=script&lang=js&"
export * from "./AttachmentsViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports